import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import GithubIcon from "./../../../assets/icons/socials/github.svg?react";
import GitlabIcon from "./../../../assets/icons/socials/gitlab.svg?react";
import BitbucketIcon from "./../../../assets/icons/socials/bitbucket.svg?react";
import ArchiveIcon from "./../../../assets/icons/archive-box.svg?react";
import LinkIcon from "./../../../assets/icons/arrow-top-right-on-square.svg?react";
import { Helmet } from "react-helmet";
import {
  getCredentialsAsync,
  openAddCredentialModal,
  removeCredentialAsync,
  selectCredentialRemoveLoading,
  selectCredentials,
  selectCredentialsLoading,
} from "../../../store/settings/registeries/registeriesSlice";
import AddCredentialModal from "./AddCredentialModal";
import QuestionModal from "../../modals/QuestionModal";
import { Credential } from "../../../types/registeries";
import { timeAgo } from "../../../utils/date";
import { useSearchParams } from "react-router-dom";
import {
  getGithubRepositoriesAsync,
  getRepositoriesAccountsAsync,
  selectGithubReposData,
  selectGithubReposLoading,
  selectRepoAccounts,
  selectRepoAccountsLoading,
  setInstallationData,
} from "../../../store/settings/registeries/repositoriesSlice";
import { selectOnStageEnv } from "../../../store/auth/authSlice";
import {
  Button,
  Typography,
  SimpleTable,
  Card,
  EmptyState,
  Flex,
} from "djuno-design";
import { getRegisteryData } from "./utils";

const RegisteriesTab = () => {
  const env = useAppSelector(selectOnStageEnv);

  const credentials = useAppSelector(selectCredentials);
  const credentialsLoading = useAppSelector(selectCredentialsLoading);

  const [query] = useSearchParams();
  const installation_id = query.get("installation_id");
  // const setup_action = query.get("setup_action");
  // const source = query.get("source");

  //accounts
  const repoAccounts = useAppSelector(selectRepoAccounts);
  const repoAccountsLoading = useAppSelector(selectRepoAccountsLoading);

  //github data
  const githubReposData = useAppSelector(selectGithubReposData);
  const githubReposLoading = useAppSelector(selectGithubReposLoading);

  const githubHtmlUrl = useMemo(() => {
    return repoAccounts.GithubAccount
      ? repoAccounts.GithubAccount.Html_Url
      : // : githubReposData && githubReposData.repositories.length > 0
        // ? githubReposData.repositories[0].owner.html_url
        "";
  }, [repoAccounts]);

  const githubAvatarUrl = useMemo(() => {
    return repoAccounts.GithubAccount
      ? repoAccounts.GithubAccount.Avatar_Url
      : // : githubReposData && githubReposData.repositories.length > 0
        // ? githubReposData.repositories[0].owner.avatar_url
        "";
  }, [repoAccounts]);

  const githubUsername = useMemo(() => {
    return repoAccounts.GithubAccount
      ? repoAccounts.GithubAccount.Login
      : // : githubReposData && githubReposData.repositories.length > 0
        // ? githubReposData.repositories[0].owner.login
        "";
  }, [repoAccounts]);

  const dispatch = useAppDispatch();

  const [deleteCredential, setDeleteCredential] = useState<Credential>();
  const credentialRemoveLoading = useAppSelector(selectCredentialRemoveLoading);

  //get credentials
  useEffect(() => {
    dispatch(getCredentialsAsync());
  }, [dispatch]);

  const handleInstallGithub = () => {
    window.location.href = import.meta.env.VITE_GITHUB_INSTALLATION_URL || "";
  };

  useEffect(() => {
    if (installation_id) {
      dispatch(
        setInstallationData({
          installationId: installation_id,
          installationModal: true,
        })
      );
    }
  }, [dispatch, installation_id]);

  useEffect(() => {
    if (
      !installation_id &&
      !repoAccountsLoading &&
      repoAccounts.GithubAccount?.Id
    ) {
      dispatch(getGithubRepositoriesAsync());
    }
  }, [dispatch, installation_id, repoAccounts, repoAccountsLoading]);

  useEffect(() => {
    dispatch(getRepositoriesAccountsAsync());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>{import.meta.env.VITE_APP_NAME} | Registeries</title>
        <meta name="description" content="" />
      </Helmet>

      <div className="w-full flex flex-col gap-10">
        <Card
          headerClassName="w-full"
          title={
            <Flex items="center" justify="between" className="w-full gap-0.5">
              <Typography.Title level={5}>
                Container Registery Credentials
              </Typography.Title>
              <Button
                className="whitespace-nowrap"
                onClick={() => dispatch(openAddCredentialModal())}
              >
                Add Credential
              </Button>
            </Flex>
          }
          description={
            <Typography>
              <Typography.Text uiType="secondary" className="!text-sm ">
                Store registry credentials to pull and deploy private images.
              </Typography.Text>{" "}
              {/* <Typography.Link
                href="https://blogs.djuno.io/privacy-notice"
                target="_blank"
                className="!text-sm"
              >
                Learn more
              </Typography.Link> */}
            </Typography>
          }
        >
          <SimpleTable
            loading={credentialsLoading}
            containerClassName="min-h-[240px]"
          >
            <SimpleTable.Head>
              <SimpleTable.Row>
                <SimpleTable.TH lable="Name" />
                <SimpleTable.TH lable="Registery" />
                <SimpleTable.TH lable="Username" />
                <SimpleTable.TH lable="Created" />
                <SimpleTable.TH lable="" />
              </SimpleTable.Row>
            </SimpleTable.Head>
            <SimpleTable.Body>
              {credentials.map((credential, i) => {
                const registeryData = getRegisteryData(credential.RegistryType);
                return (
                  <SimpleTable.Row key={i}>
                    <SimpleTable.TD>
                      <Typography.Text className="!text-xs md:!text-sm whitespace-pre">
                        {credential.Name}
                      </Typography.Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      {/* <Tooltip
                        clickable
                        className="!bg-gray-200"
                        content={registeryData.Description}
                      > */}
                      <div className="flex items-center gap-1">
                        {registeryData.Icon}
                        <Typography.Text className="!text-xs md:!text-sm">
                          {registeryData.Title}
                        </Typography.Text>
                      </div>
                      {/* </Tooltip> */}
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Typography.Text className="!text-xs md:!text-sm">
                        {credential.UserName}
                      </Typography.Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Typography.Text className="!text-xs md:!text-sm">
                        {timeAgo(credential.CreatedAt)}
                      </Typography.Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <div className="flex w-full justify-end">
                        {env?.IsAccountOwner && (
                          <div
                            onClick={() => setDeleteCredential(credential)}
                            className="p-2 rounded-md dark:border-dark-2 hover:dark:bg-dark-2 hover:bg-slate-200 cursor-pointer"
                          >
                            <ArchiveIcon className="w-4 h-4 dark:text-slate-100 text-slate-800" />
                          </div>
                        )}
                      </div>
                    </SimpleTable.TD>
                  </SimpleTable.Row>
                );
              })}
              {credentials.length === 0 && (
                <SimpleTable.Row withoutHoverStyle={true} className="h-[200px]">
                  <SimpleTable.TD colSpan={5} className="!border-none">
                    <EmptyState />
                  </SimpleTable.TD>
                </SimpleTable.Row>
              )}
            </SimpleTable.Body>
          </SimpleTable>
        </Card>

        <Card title="Code repository">
          <div className="flex flex-col py-5 gap-4">
            <div className="flex items-center">
              <div className="w-32">
                <Typography.Text className="!text-sm">Github</Typography.Text>
              </div>
              {repoAccounts.GithubAccount === null && (
                <Button
                  loading={repoAccountsLoading || githubReposLoading}
                  onClick={handleInstallGithub}
                >
                  <GithubIcon className="w-4" />
                  <Typography.Text uiType="transparent" className="!text-sm">
                    Connect Github
                  </Typography.Text>
                </Button>
              )}
              {repoAccounts.GithubAccount !== null && (
                <Typography.Link
                  href={githubHtmlUrl}
                  target="_blank"
                  className="!flex !items-center !gap-1 !text-slate-700 hover:!text-slate-900 dark:!text-slate-300 dark:hover:!text-slate-200"
                >
                  <div className="-mr- w-7 h-7 bg-gray-200 bg-gray-300/30 dark:bg-gray-500/20 rounded-full flex items-center text-center justify-center overflow-hidden">
                    <img
                      alt={githubUsername}
                      className="w-full"
                      src={githubAvatarUrl}
                    />
                  </div>
                  <Typography.Text
                    className="!text-sm !font-semibold"
                    uiType="transparent"
                  >
                    {githubUsername}
                  </Typography.Text>
                  <LinkIcon className="w-4" />
                  {githubReposData && (
                    <Typography.Text
                      uiType="secondary"
                      className="!text-xs !ml-2"
                    >
                      {githubReposData.length} repo
                      {githubReposData && githubReposData.length > 1 && "s"}
                    </Typography.Text>
                  )}
                </Typography.Link>
              )}
            </div>
            <div className="flex items-center">
              <div className="w-32">
                <Typography.Text className="!text-sm">
                  Bitbucket
                </Typography.Text>
              </div>
              <Button disabled={true}>
                <BitbucketIcon className="w-4" />
                <Typography.Text uiType="transparent" className="!text-sm">
                  Connect Bitbucket
                </Typography.Text>
              </Button>
            </div>
            <div className="flex items-center">
              <div className="w-32">
                <Typography.Text className="!text-sm">Gitlab</Typography.Text>
              </div>
              <Button disabled={true}>
                <GitlabIcon className="w-4" />
                <Typography.Text uiType="transparent" className="!text-sm">
                  Connect Gitlab
                </Typography.Text>
              </Button>
            </div>
          </div>
        </Card>
        <AddCredentialModal />
        <QuestionModal
          title="Remove Credential"
          isOpen={deleteCredential !== undefined}
          onClose={() => setDeleteCredential(undefined)}
          confirmButtonType="danger"
          onConfirm={() => {
            if (deleteCredential)
              dispatch(removeCredentialAsync({ id: deleteCredential.Id })).then(
                (action) => {
                  if (
                    action.type === "registeries/credentials/remove/fulfilled"
                  ) {
                    dispatch(getCredentialsAsync());
                    setDeleteCredential(undefined);
                  }
                }
              );
          }}
          loading={credentialRemoveLoading}
        />
      </div>
    </>
  );
};

export default RegisteriesTab;
